import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Button, Grid, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSublimationsByType } from "../../api/broker";
import { Spinner } from "../../components/Loading/Spinner";
import CreditsDetails from "../../components/Table/Suscriptions/Credits/CreditsDetails";
import CreditsGraphs from "../../components/Table/Suscriptions/Credits/CreditsGraphs";
import CreditsSuscriptionsTable from "../../components/Table/Suscriptions/Credits/CreditsSuscriptionsTable";

const SingleSuscriptCreditPage = () => {
  const { idOrganization } = useParams();
  const [growthData, setGrowthData] = useState<any[]>([]);

  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  // Funcion para cargar las sublimaciones por organizacion
  const load = async (idOrganization: string) => {
    setIsLoading(true);
    try {
      const res = await getSublimationsByType(idOrganization);
      console.log(res.data);
      if (res.data.statusCode === 200) {
        const data = res.data.body.map((item: any) => {
          const date = new Date(item.fecha);
          const monthName = date.toLocaleString("default", {
            month: "long",
          });
          const day = date.getDay();
          console.log({ day });
          return {
            month: monthName,
            day,
            creditosGastados: item.creditos_gastados,
          };
        });
        const uniqueMonths = new Set(data.map((item: any) => item.month));
        // Si solo hay un mes, usa solo el día; si hay varios meses, incluye el nombre del mes
        const formattedData = data.map((item: any) => ({
          name:
            uniqueMonths.size === 1 ? item.day : `${item.month} ${item.day}`,
          value: item.creditosGastados,
        }));
        setGrowthData(formattedData);
      }
    } catch (error) {
      console.error("Error al cargar sublimacion por organización");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (idOrganization) {
      load(idOrganization);
    }
  }, [idOrganization]);

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button onClick={() => navigate(-1)} sx={{ color: "#336B87" }}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Suscripción</b> | Detalles
        </Typography>
      </Grid>

      {isLoading ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          <Grid item container spacing={3}>
            {/* Descripción del plan */}
            <Grid item xs={12} md={4}>
              <CreditsDetails />
            </Grid>

            {/* Gráficos de créditos */}
            <Grid item xs={12} md={8}>
              <CreditsGraphs
                setIsLoading={setIsLoading}
                growthData={growthData}
              />
            </Grid>
          </Grid>

          {/* Tabla de sublimación de créditos */}
          <Grid item xs={12}>
            <Paper sx={{ padding: 2 }}>
              <Typography variant={"h5"}>Sublimación de créditos</Typography>
              <CreditsSuscriptionsTable />
            </Paper>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SingleSuscriptCreditPage;
